export default {"src":"/_next/static/media/cn-logo-dark.19354fc3.svg","height":32,"width":201,"blurWidth":0,"blurHeight":0};